import React, { Component } from 'react'
import PropTypes from 'prop-types'

import i18n from './../../../config/i18n'

import LinkItem from './LinkItem'
import { DetailsLink } from '../DetailsLink/DetailsLink'

import './LinksList.css'

class LinksList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            expand: false
        }
    }

    toggleList = () => {
        const expand = this.state.expand ? false : true

        this.setState({
            expand
        })
    }

    render() {
        const { links, dark } = this.props
        const { expand } = this.state
        const expandClass = links.length > 5 ? 'expand-list' : ''
        const toggleListClass = this.state.expand ? 'expanded' : 'collapsed'
        const moreTitle = expand ? 'show-less.general-title' : 'show-more.general-title'
        const className = dark ? 'dark' : ''

        return (
            <>
                <ul
                    className={`links-list links-list--${className} links-list--${toggleListClass} links-list__toggle ${expandClass}`}
                    onClick={this.toggleList}
                >
                    {links.map(linkItem => (
                        <LinkItem item={linkItem} className={className} key={linkItem.slug} />
                    ))}
                </ul>
                <div className={`links-list__toggle links-list__toggle--${toggleListClass}`}>
                    {links.length > 5 && (
                        <DetailsLink
                            text={i18n.t(moreTitle)}
                            onDetailsClick={this.toggleList}
                            white={dark}
                        />
                    )}
                </div>
            </>
        )
    }
}

LinksList.propTypes = {
    links: PropTypes.array.isRequired,
    moreTitle: PropTypes.string,
    lessTitle: PropTypes.string,
    dark: PropTypes.bool
}

export { LinksList }
